export default __webpack_public_path__ + "static/media/July2020.8b9889e1.png";